export const oneYearLater = ( dateBook: number ) => {
  const date = new Date( dateBook );
  date.setFullYear( date.getFullYear() + 1 );
  return date;
};
